import { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'

import { occtoAreaDigit } from '~/models/area'

/**
 * 系統コードの 1 桁目と選んだエリアのエリアコードが合わない時の情報。
 */
export type SystemCodeAreaMismatch = {
  /** 系統コードの 1 桁目 (数字または英字)。 */
  digit: string
  /** 選んだエリアの広域機関のエリアコード (北海道 '1' … 九州 '9'、沖縄 '0')。 */
  areaDigit: string
}

/**
 * 系統コードの 1 桁目が、選んだエリアのエリアコードと違えば返す (違わなければ undefined)。
 *
 * 広域機関の記載要領 ver6.1 §5.1 p.116「発電所マスタチェック」と FAQ 2-37 に
 * 「[計画] すべての系統コード上 1 桁 = [マスタ] 各電源所属エリアコード」があり、合わないと
 * 計画が受け付けられない。ただし通例であって登録の制限まではできないので、
 * 注意を出すだけで保存は止めない (DE 判断 2026-10-29)。
 *
 * 1 桁目が英字でも返す: 広域機関は上 1 桁 = エリアコードを確かめるので、英字始まりは
 * どのエリアコードとも一致せず、受け付けられない側に入る (DE 判断 2026-10-29)。
 * 比べられない時だけ undefined (出さない): 系統コード未入力・エリア未選択。
 */
export function findSystemCodeAreaMismatch(
  plantCode: string | undefined,
  areaCode: AreaCode | undefined,
): SystemCodeAreaMismatch | undefined {
  if (!plantCode || areaCode === undefined) return undefined
  const digit = plantCode.charAt(0)
  const areaDigit = occtoAreaDigit(areaCode)
  if (areaDigit === undefined || areaDigit === digit) return undefined
  return { digit, areaDigit }
}
